import { render } from "./change_password.vue?vue&type=template&id=279bf6a8"
import script from "./change_password.vue?vue&type=script&lang=js"
export * from "./change_password.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/pages/usersettings/change_password.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "279bf6a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('279bf6a8', __exports__)) {
    api.reload('279bf6a8', __exports__)
  }
  
  module.hot.accept("./change_password.vue?vue&type=template&id=279bf6a8", () => {
    api.rerender('279bf6a8', render)
  })

}


export default __exports__